module.exports = __webpack_public_path__ + "static/media/ATKV_Korporatief.48eaa245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ATKV_Korporatief.png
// module id = 752
// module chunks = 3